/**
 * Checks if the current URL hash contains a search query (q= parameter).
 * Used to conditionally render the title skeleton — the title QuerySummary
 * only renders when there's an active search query.
 */
export function hasSearchQuery(): boolean {
  return typeof window !== 'undefined' && window.location.hash.includes('q=');
}
